import { lazy, Suspense } from "react";
import SEOHead from "@/components/SEOHead";
import Header from "@/components/Header";
import Hero from "@/components/Hero";

const Benefits = lazy(() => import("@/components/Benefits"));
const VideoSection = lazy(() => import("@/components/VideoSection"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const FAQ = lazy(() => import("@/components/FAQ"));
const Footer = lazy(() => import("@/components/Footer"));
const WhatsAppFloat = lazy(() => import("@/components/WhatsAppFloat"));

const SectionFallback = () => <div className="h-12" aria-hidden="true" />;

const Index = () => {
  return (
    <>
      <SEOHead />

      <div className="flex min-h-screen flex-col">
        <Header />

        <main className="flex-1">
          <Hero />
          <Suspense fallback={<SectionFallback />}>
            <Benefits />
            <VideoSection />
            <Testimonials />
            <FAQ />
          </Suspense>
        </main>

        <Suspense fallback={null}>
          <Footer />
          <WhatsAppFloat />
        </Suspense>
      </div>
    </>
  );
};

export default Index;
